<template>
    <div class="container">
        <div class="text-center">
            <Loading class="mt-3" v-if="loading && isAuthenticated" />

            <Login v-if="!isAuthenticated"></Login>
            <div class="mt-0 mx-auto col-md-6" v-if="isAuthenticated">
                <div class="row">
                    <div class="col">
                        <div class="float-right">
                            <b-button v-if="isAuthenticated && !loading" variant="primary" class="ml-2 mb-2"
                                @click="reLoadData">
                                <b-icon-arrow-repeat class="mt-1" font-scale="1.0" />
                            </b-button>
                        </div>
                    </div>
                </div>

                <b-list-group v-if="getOrdersList.length" class="text-left m-auto border border-primary">
                    <div v-if="getOrdersList.length">
                        <b-list-group-item class="delivery-item" v-for="item in getOrdersList" :key="item.ObjectId"
                            :class="{ hasInstruction: item.ShipmentDriverInstruction && item.ShipmentDriverInstruction.trim() }"
                            href="#">

                            <b-badge variant="primary" v-if="item.DropAddress" class="position-absolute"
                                style="left: 5px;top: 5px;">{{ $t('Drop') }}</b-badge>
                            <b-badge variant="primary" v-if="item.LoadAddress" class="position-absolute"
                                style="left: 5px;top: 5px;">{{ $t('Load') }}</b-badge>

                            <b-badge variant="danger" v-if="item.NonDelivery != 0" class="position-absolute"
                                style="right: 5px;top: 5px;"><small>{{ $t('non-delivery') }}</small></b-badge>

                            <b-col class="d-flex pr-0">
                                <b-icon-geo-alt class="mt-1" font-scale="2.5" />

                                <b-col class="ml-0 mr-5" @click="orderDetails(item.ShipmentId)"
                                    v-if="item.DropAddress && item.NonDelivery == 0">
                                    <p class="m-0">{{ item.DropAddress }} </p>
                                    <p class="m-0 text-secondary mb-2">{{ item.DropName }}</p>
                                    <p class="m-0 text-secondary mb-2">{{ item.ShipmentDriverInstruction }}</p>
                                </b-col>
                                <b-col class="mx-0 mr-5" @click="orderDetails(item.ShipmentId)"
                                    v-if="item.LoadAddress && item.NonDelivery == 0">
                                    <p class="m-0">{{ item.LoadAddress }}</p>
                                    <p class="m-0 text-secondary">{{ item.LoadName }}</p>
                                    <p class="m-0 text-secondary mb-2">{{ item.ShipmentDriverInstruction }}</p>
                                </b-col>

                                <b-col class="ml-0 mr-5" v-if="item.DropAddress && item.NonDelivery != 0">
                                    <p class="m-0">{{ item.DropAddress }}</p>
                                    <p class="m-0 text-secondary mb-2">{{ item.DropName }}</p>
                                    <p class="m-0 text-secondary mb-2">{{ item.ShipmentDriverInstruction }}</p>
                                </b-col>
                                <b-col class="mx-0 mr-5" v-if="item.LoadAddress && item.NonDelivery != 0">
                                    <p class="m-0">{{ item.LoadAddress }}</p>
                                    <p class="m-0 text-secondary">{{ item.LoadName }}</p>
                                    <p class="m-0 text-secondary mb-2">{{ item.ShipmentDriverInstruction }}</p>
                                </b-col>

                            </b-col>

                            <small class="position-absolute text-secondary" style="right:5px; bottom: 0; ">Driver:
                                {{ item.DriverName }}</small>

                            <b-dropdown size="md" variant="primary" right class="position-absolute"
                                style="right: 5px; top: 30%;">
                                <template v-slot:button-content>
                                    <b-icon-truck class="mr-1" v-if="item.NonDelivery == 0"
                                        @click="orderDetails(item.ShipmentId)" />
                                    <b-icon-truck class="mr-1" v-if="item.NonDelivery != 0" />
                                </template>

                                <b-dropdown-item v-if="item.NonDelivery == 0" @click="orderDetails(item.ShipmentId)">
                                    <b-icon-list-task />
                                    {{ $t('Details') }}
                                </b-dropdown-item>

                                <b-dropdown-item @click="nonDelivery(item.ShipmentId)" v-if="item.NonDelivery == 0">
                                    <b-icon-x-circle />
                                    {{ $t('NonDelivery') }}
                                </b-dropdown-item>

                                <b-dropdown-item @click="solveNonDelivery(item.ShipmentId)" v-if="item.NonDelivery != 0">
                                    <b-icon-check2-all font-scale="1" />
                                    {{ $t('SolveNonDelivery') }}
                                </b-dropdown-item>
                            </b-dropdown>
                        </b-list-group-item>
                    </div>
                </b-list-group>
                <div v-else-if="!loading" class="text-center">
                    <h5>{{ $t('TherearenoordersToday') }}</h5>
                </div>
            </div>
        </div>
    </div>
</template>

<style>
.home {
    display: flex;
    align-items: center;
    flex-direction: column;
}

.delivery-item {
    min-height: 80px;
}

.hasInstruction::before {
    color: red;
    content: '';
    height: .65em;
    width: .65em;
    background: currentColor;
    border-radius: 50%;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
}
</style>

<script>
import { mapGetters } from "vuex";
import { ORDERSLIST_REQUEST } from "actions/ordersList";

export default {
    name: "Home",
    data() {
        return {
            signature: null,
        };
    },
    watch: {
        isOnline: function (val) {
            if (val && this.isAuthenticated) {
                this.$store.dispatch(ORDERSLIST_REQUEST);
            }
            if (!val)
                this.$root.$children[0].$refs.requestToats.makeToast('warning', 'no internet connection', 'You are using app in offline mode');
        }
    },
    mounted() {
        if (this.isOnline && this.isAuthenticated)
            this.$store.dispatch(ORDERSLIST_REQUEST);
        if (!this.isOnline)
            this.$root.$children[0].$refs.requestToats.makeToast('warning', 'no internet connection', 'You are using app in offline mode');
    },
    computed: {
        ...mapGetters(["isAuthenticated", "authStatus", "getOrdersList", "ordersListStatus", "isOrdersListHasItems"]),
        loading: function () {
            return this.authStatus === "loading" || this.ordersListStatus === "loading";
        }
    },
    methods: {
        noOrdersNotify: function () {
            this.$root.$children[0].$refs.requestToats.makeToast('warning', 'no internet connection', 'You are using app in offline mode');
        },
        reLoadData: function () {
            this.$store.dispatch(ORDERSLIST_REQUEST);
        },
        orderDetails: function (id) {
            this.$router.push("/orderdetails/" + id);
        },
        nonDelivery: function (id) {
            this.$router.push("/non-delivery/" + id);
        },
        solveNonDelivery: function (id) {
            this.$router.push("/solve-non-delivery/" + id);
        }
    }
};
</script>

